import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { useLocation } from "@tanstack/react-router";

export const useIsFromEventsDirectory = () => {
  const { isCircleV4 } = useCircleV4();
  const from = useLocation({ select: location => location.state.from });

  return isCircleV4 && typeof from === "object" && from?.path === "/events";
};
